export default __webpack_public_path__ + "static/media/archies1.4005e431.png";